export default "__VITE_ASSET__CumsNolJ__"